import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "./Reveal";
import { WhatsGlyph } from "./WhatsGlyph";
import { faqs, waLink, DEFAULT_MSG } from "@/data/site";

export const Faq = () => (
  <section id="faq" className="relative py-24 sm:py-28" data-testid="faq-section">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 sm:px-8 lg:grid-cols-12">
      <Reveal className="lg:col-span-5">
        <div className="lg:sticky lg:top-28">
          <p className="mb-4 font-mono text-[11px] font-medium uppercase tracking-[0.25em] text-neon">
            Dúvidas frequentes
          </p>
          <h2 className="font-display text-3xl font-bold uppercase leading-[1.02] tracking-tight text-white sm:text-4xl lg:text-5xl">
            Perguntas?
            <br />
            A gente responde.
          </h2>
          <p className="mt-6 max-w-sm text-base leading-relaxed text-mist">
            Não achou a sua dúvida aqui? Chama no WhatsApp que uma pessoa de
            verdade responde em minutos.
          </p>
          <a
            href={waLink(DEFAULT_MSG)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="faq-whatsapp-cta"
            className="mt-8 inline-flex items-center gap-2.5 rounded-full border border-wa/40 px-7 py-3.5 font-display text-base font-bold uppercase tracking-wider text-wa transition-colors hover:bg-wa hover:text-[#052e16]"
          >
            <WhatsGlyph className="h-4 w-4" />
            Tirar dúvidas no WhatsApp
          </a>
        </div>
      </Reveal>

      <Reveal delay={0.1} className="lg:col-span-7">
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-white/10"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="py-6 text-left font-display text-lg font-bold uppercase tracking-wide text-white hover:text-neon hover:no-underline sm:text-xl">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-base leading-relaxed text-mist">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
